import { styled } from '@mui/styles';

type WrapperProps = {
  theme: any;
};

export const CircleTextPercentageWrapper = styled('text')(({ theme }: WrapperProps) => ({
  fill: theme.palette.colorPalette[5],
  fontSize: '0.75em',
  fontFamily: theme.typography.fontFamily,
  textAnchor: 'middle',
  dominantBaseline: 'middle'
}));

export const CircleTextPercentageSignWrapper = styled('text')(({ theme }: WrapperProps) => ({
  fontFamily: theme.typography.fontFamily,
  fill: theme.palette.colorPalette[5],
  fontSize: '0.19em',
  textAnchor: 'start'
}));
